export default "__VITE_ASSET__DEq9_2GY__"